
import type { PropType } from 'vue'
import type { DataTableColumn, FieldValue } from '../models'
import { computed, defineComponent, ref, watch } from 'vue'
import { StringUtils } from '../utils/string.utils'
import DataTable from './crud/data-table.component.vue'
import Searchbox from './shared/search-box.component.vue'

export default defineComponent({
  name: 'FieldValues',
  components: {
    DataTable,
    Searchbox,
  },
  props: {
    data: {
      type: Array as PropType<Array<FieldValue>>,
      required: true,
    },
    query: {
      type: String,
      default: undefined,
    },
    loading: {
      type: Boolean,
    },
  },
  emits: {
    valueClick: (value: FieldValue) => {},
    queryChange: (value: string) => {},
  },
  setup(props) {
    const baseClass = 'epb-field-values'

    const columns: Array<DataTableColumn> = [
      {
        id: 'name',
      },
      {
        id: 'externalId',
        width: '25%',
      },
    ]

    const searchbox = ref()

    const dataTable = ref()

    const expandedChildrenIds = ref<Array<string>>([])

    const filteredData = computed<Array<FieldValue>>(() => {
      let result = props.data
      if (props.query) {
        result = result.filter(value => valueMatchesQuery(value))
      }
      return result
    })

    function valueMatchesQuery(value: FieldValue): boolean {
      return !!getMatchingParentIds([value])
    }

    function getMatchingParentIds(
      values: Array<FieldValue>,
      parentIds: Array<string> = [],
    ): Array<string> {
      let match = false
      const normalizedQuery = StringUtils.normalize(props.query)
      values.forEach(value => {
        const normalizedName = StringUtils.normalize(value.name)
        if (
          normalizedName.includes(normalizedQuery) ||
          value.id.toLowerCase().includes(normalizedQuery)
        ) {
          match = true
        } else {
          parentIds.push(value.id)
          const childrenMatch = !!getMatchingParentIds(value.children, parentIds)
          if (!childrenMatch) {
            parentIds.pop()
          } else {
            match = true
          }
        }
      })
      return match ? parentIds : undefined
    }

    watch(filteredData, value => {
      expandedChildrenIds.value = (props.query && getMatchingParentIds(value)) || []
      dataTable.value.resetScroll()
    })

    return {
      baseClass,
      columns,
      searchbox,
      dataTable,
      expandedChildrenIds,
      filteredData,
    }
  },
})
